module.exports = __webpack_public_path__ + "static/img/6.de89bed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/6.png
// module id = /+Lp
// module chunks = 0